import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useData } from '../context/DataContext';
export const Login: React.FC = () => {
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const {
    setUser
  } = useAuth();
  const {
    users
  } = useData();
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    const user = users.find(u => u.name.toLowerCase() === name.toLowerCase() && u.password === password);
    if (user) {
      setUser(user);
    } else {
      setError('Invalid name or password');
    }
  };
  return <div className="min-h-screen bg-slate-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8" data-id="element-52">
      <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-53">
        <div className="flex justify-center" data-id="element-54">
          <img src="https://cdn.magicpatterns.com/uploads/d6s42Hs2WEUAvLVPoFhjsD/Copy_of_Clean_Elegant_Transparent_Logo_(3).png" alt="BMED Medical Centre Logo" className="h-32 w-32 object-contain" data-id="element-55" />
        </div>
        <h2 className="mt-4 text-center text-3xl font-extrabold text-gray-900" data-id="element-56">
          BMED CARE
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600" data-id="element-57">
          Hospital Management System
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-58">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10 border border-gray-100" data-id="element-59">
          <form className="space-y-6" onSubmit={handleLogin} data-id="element-60">
            {error && <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-md text-sm" data-id="element-61">
                {error}
              </div>}

            <div data-id="element-62">
              <label htmlFor="name" className="block text-sm font-medium text-gray-700" data-id="element-63">
                Full Name
              </label>
              <div className="mt-1" data-id="element-64">
                <input id="name" name="name" type="text" required value={name} onChange={e => setName(e.target.value)} className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-teal-500 focus:border-teal-500 sm:text-sm" placeholder="e.g. Mwamba Chilufya" data-id="element-65" />
              </div>
            </div>

            <div data-id="element-66">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700" data-id="element-67">
                Password
              </label>
              <div className="mt-1" data-id="element-68">
                <input id="password" name="password" type="password" required value={password} onChange={e => setPassword(e.target.value)} className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-teal-500 focus:border-teal-500 sm:text-sm" data-id="element-69" />
              </div>
            </div>

            <div data-id="element-70">
              <button type="submit" className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500 transition-colors" data-id="element-71">
                Sign in
              </button>
            </div>
          </form>

          <div className="mt-6 text-xs text-gray-500 text-center" data-id="element-72">
            <p data-id="element-73">Default Admin: Name: Admin | Password: Admin@123</p>
          </div>
        </div>
      </div>
    </div>;
};